import React, { useState, useEffect } from 'react';
import {  useParams } from 'react-router-dom';
import { collection, query, onSnapshot, doc, updateDoc, getDocs } from 'firebase/firestore';
import { db } from './firebaseConfig';
import './game.css';

function GuestQuestions() {
    const [isTriviaOn, setIsTriviaOn] = useState(false);
    const [questions, setQuestions] = useState([]);
    const [participantQuestion, setParticipantQuestion] = useState("");
    const { documentId } = useParams();
    const [guestCurrentAnswer, setGuestCurrentAnswer] = useState(null);
    const [guestAllAnswers, setGuestAllAnswers] = useState([]);

    const fetchQuestion = async () => {

        var sub = await getDocs(collection(db, "question"))
            .then((querySnapshot) => {

                const newData = querySnapshot.docs
                    .map((doc) => ({ ...doc.data(), id: doc.id }));

                setQuestions(newData.sort((a, b) => (a.sequence || 0) - (b.sequence || 0)))
            })

        return sub;
    }

    useEffect(() => {
        fetchQuestion();


    }, [documentId])


    useEffect(() => {




        const unsub = onSnapshot(doc(db, "isTriviaOn", "s5y7fVw6BM5iOZs75VdM"), (doc) => {

            const data = doc.data();

            setIsTriviaOn(Boolean(data?.isOn))

        });

        
        const questionCollection = collection(db, 'question');
        const questionQuery = query(questionCollection);

        const unsubscribeQuestions = onSnapshot(questionQuery, () => fetchQuestion());


        return () => {
            unsub();
            unsubscribeQuestions();
        };

    }, []);


    useEffect(() => {
        const fetchGuestData = async () => {

            const unsub = onSnapshot(doc(db, "guest", documentId), (doc) => {
                const guestData = doc.data() || {};

                const answers = Array.isArray(guestData.answers) ? guestData.answers : [];

                const currentAnswer = answers.filter((x) => x.questionId === participantQuestion);

                setGuestAllAnswers(answers)
                if (currentAnswer.length > 0) {
                    setGuestCurrentAnswer(currentAnswer[0])
                }
                else {
                    setGuestCurrentAnswer(null)
                }

            });

            return () => unsub();
        };

        fetchGuestData();
    }, [documentId, participantQuestion]);



    useEffect(() => {

        const participantQuestionCollection = collection(db, 'participantQuestion');

        const participantQuestionQuery = query(participantQuestionCollection);

        const unsubscribe = onSnapshot(participantQuestionQuery, (snapshot) => {
            const current = snapshot.docs[0]?.data()?.id || "";
            setParticipantQuestion(current)

        });


        return () => unsubscribe();

    }, []);

    function getQuestionText(itemText) {
        try {
            return (JSON.parse(itemText)).text;
        } catch {
            return "";
        }
    }

    function getAnswerCorrectId(itemText) {
        try {
            return (JSON.parse(itemText)).correctAnswerId;
        } catch {
            return null;
        }
    }


    function getAnswers(itemText) {
        try {
            return (JSON.parse(itemText)).answers || [];
        } catch {
            return [];
        }
    }

    function submitAnswer(guestId, questionId, answerId) {

        const item = { answerId: answerId, questionId: questionId };

        const temp = [...guestAllAnswers]

        const foundIndex = temp.findIndex(x => x.questionId === item.questionId);

        if (foundIndex === -1) {
            temp.push(item)
        }
        else {
            temp[foundIndex] = item;
        }

        setGuestAllAnswers(temp)

        const updatedGuest = {
            answers: temp
        };

        const guestDocRef = doc(db, 'guest', guestId);
        updateDoc(guestDocRef, updatedGuest).catch((error) => console.error('Error saving answer:', error));

    }


    return (
        <>
        {/* <Link to={`/guest-access/${documentId}`}>Back to Modify My Name</Link> */}
        <div className="game-shell">
            {
                (!isTriviaOn || (isTriviaOn && !participantQuestion))&& <div className="player-shell">
                    <div className="player-card">
                        <p className="game-kicker">You are checked in</p>
                        <h1 className="player-question">Good Times, Great Company</h1>
                        <p className="player-status">Listen to the host. The answers will appear here when it is time to choose.</p>
                    </div>
                </div>
            }
            
            {
                
                questions.map((item, index) => {
                    return <div key={item.id || index}>  {participantQuestion === item.id &&
                        
                        <div className="player-shell" key={index}>
                                
                             
                            {
                                isTriviaOn && <>
                                    
                                    <div className="player-card">
                                    <h1 className="player-question">{getQuestionText(item.text)}</h1>
                                    <p className="player-status">{guestCurrentAnswer ? "Answer saved. You can change it until the host moves on." : "Choose your answer."}</p>
                                    <div className="answer-grid player-grid">
                                    {
                                        getAnswers(item.text).map((answer, answerIndex) => {
                                            const isSelected = guestCurrentAnswer?.answerId === answer.id;
                                            return <button
                                                className={`answer-tile ${isSelected ? 'is-selected' : ''}`}
                                                key={answer.id || answerIndex}
                                                onClick={() => { submitAnswer(documentId, participantQuestion, answer.id) }}
                                                type="button"
                                            >
                                                <span className="answer-marker">{answerIndex + 1}</span>
                                                {answer.text}
                                                {isSelected ? " - selected" : ""}
                                                {
                                                    (getAnswerCorrectId(item.text) === answer.id ) && <>
                                                        {/* Corect */}
                                                    </>
                                                } 
                                            </button>
                                        })
                                    }
                                    </div>
                                    </div>

                                </>
                            }


                        </div>}

                    </div>
                })
            }
            
        </div>
        </>
    )
}

export default GuestQuestions
